  import React, { Component } from "react";
  import PropTypes from "prop-types";
  import {
    tr,
    th,
    td,
    thead,
    Table,
    div,
    tbody,
    Button,
    DropdownButton,
    ButtonGroup,
    MenuItem,
    FormGroup,
    InputGroup,
    FormControl,
    Modal,
    ControlLabel,
    Alert,
    Tab,
    Tabs,
    Row,
    Col,
    Glyphicon
  } from "react-bootstrap";
  import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
  import { connect } from "react-redux";
  import { bindActionCreators, compose } from "redux";
  import { createHashHistory } from "history";
  import { withRouter, Link } from "react-router-dom";
  import { getDealList, getOrderDeatil, getDealPending, getDealUpcoming, getDealPast, deleteDeal, confirmClose, uploadExternalVoucher, getDealSchedule, updateQuantity } from "../../../redux/actions/dealActions";
  import isEmpty from "lodash.isempty";
  import Pagination from "react-paginating";
  import "../../../style/react-paginating.css";
  import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
  import Dialog from "react-bootstrap-dialog";
  import "../../../style/listPage.scss";
  import "react-responsive-tabs/styles.css";
  import {aclUtil} from "../../util";
  import { CSVLink } from "react-csv";
  import {getSiteCity} from "../../../redux/actions/frontActions";

  let rand = require("random-key");
  const options = [25, 50, 75, 100, 125,150,175,200];
  const history = createHashHistory();
  let merchantID = "";
  class DealtList extends Component {
    constructor(props) {
      let csvData = [
        [
        "VoucherNumber"
        ],
        [
        "5555555555"
        ]
      ];
      super(props);
      this.state = {
        menuKey: 'VIEW_OFFERS',
        dealList: [],
        dealPendingList: [],
        dealPastList: [],
        dealUpcomingList: [],
        dealScheduleList: [],
        totalRecords: 0,
        limit: 10,
        search: "",
        perPage: 0,
        currentPage: 1,
        pageCount: 0,
        pendingCurrentPage: 1, 
        pendingTotalRecords: 0, 
        pendingPerPage: 0, 
        pendingPageCount: 0,
        upcomingCurrentPage: 1, 
        scheduleCurrentPage: 1,
        upcomingTotalRecords: 0,
        upcomingPerPage: 0, 
        upcomingPageCount: 0,
        scheduleTotalRecords: 0,
        schedulePerPage: 0,
        schedulePageCount: 0,
        pastCurrentPage: 1,
        pastTotalRecords: 0, 
        pastPerPage: 0, 
        pastPageCount: 0,
        alertMessage: "",
        msgType: "success",
        skuCodeIcon: "fa fa-sort-down",
        skuCodeOrderBy: "skuCode",
        executionDateTimeIcon: "fa fa-sort-down",
        merchantNameIcon: "fa fa-sort-down",
        dealTextIcon: "fa fa-sort-down",
        revenueIcon: "fa fa-sort-down",
        startDateTimeIcon: "fa fa-sort-down",
        skuCodesortOrder: "DESC",
        executionDateTimesortOrder: "DESC",
        merchantNamesortOrder: "DESC",
        dealTextsortOrder: "DESC",
        startDateTimesortOrder: "DESC",
        path: ["Home", "Manage Deal List"],
        links: ["home", "dealList"],
        show: false,
        dealID: "",
        alertMessage: "",
        orderby: "",
        direction: "",
        viewOrders: "",
        selectedOption:options[0],
        messageShow: false,
        contractID: '',
        loadVoucherStatus: false,
        selectedFile: '',
        csvData: csvData,
        uploadButton: 'Upload File',
        updateqty: '',
        updatekey: 'Update',
        cityList: '',
        default_city: '',
      };
      this.handleSelect = this.handleSelect.bind(this);
      this.handleSearch = this.handleSearch.bind(this);
      this.handleChangeExecution = this.handleChangeExecution.bind(this);

      // Alert
      this.handleDismiss = this.handleDismiss.bind(this);
      this.handleShow = this.handleShow.bind(this);
      this.confirmDelete = this.confirmDelete.bind(this);

      this.viewOrders = this.viewOrders.bind(this);
      this.handleFormData = this.handleFormData.bind(this);
    }

    handleClose() {
      this.setState({
        show: false,
        viewOrders: "",
        orderID: "",
      });
    }

    handlePopupShow() {
      this.setState({
        show: true,
      });
    }

    viewOrders = (e) => {
      let id = e.target.attributes.getNamedItem("data-id").value;
      this.setState({orderID: id});
      this.props.getOrderDeatil(id, localStorage.getItem("siteID"));
    }

    closeOffer = (e) => {
      let id = e.target.attributes.getNamedItem("data-id").value;
      this.dialog.show({
        body: "Are you sure you want to close this offer?",
        actions: [
          Dialog.CancelAction(),
          Dialog.OKAction(() => {
            this.confirmClose(id);
          })
        ]
      });
    }

    loadVoucher = (e) => {
      let contractID = e.target.attributes.getNamedItem("data-id").value;
      this.setState({
        contractID : contractID,
        loadVoucherStatus :  true,
      });
    }

    loadVoucherClose = (e) => {
      this.setState({
        contractID : '',
        loadVoucherStatus :  false,
      });
    }

    handleFormData(event) {
      this.setState({ selectedFile: event.target.files });
    }

    uploadVoucher = (e) => {
      if(this.state.selectedFile !== ''){
        this.setState({uploadButton : 'Uploading..'});
        let images = this.state.selectedFile;
        const formData = new FormData();
        formData.append("contractID", this.state.contractID);
        formData.append("file", images[0]);
        formData.append("site_id", localStorage.getItem("siteID"));
        this.props.uploadExternalVoucher(formData);
      }else{
        alert('Please choose a file.');
      }

    }

    confirmClose = (id) => {
      this.props.confirmClose({dealID: id, site_id: localStorage.getItem("siteID")});
    }

    handleDismiss() {
      this.setState({ messageShow: false });
    }

    handleShow() {
      this.setState({ messageShow: true });
    }

    handleSelect(eventKey, event) {
      this.setState({
        selectedOption: options[eventKey]
      });
      const postData = {
        page: this.state.currentPage,
        limit: this.state.selectedOption,
        search: this.state.search,
        merchantID: merchantID, 
        cityID: this.state.default_city,
        site_id: localStorage.getItem("siteID")
      };
      this.props.getDealList(postData);
    }

    confirmDelete = dealID => {
      this.props.deleteDeal(dealID);
    };

    handleChangeExecution(e) {
      this.setState({ [e.target.name]: e.target.value });
    }

    handleSearch(e) {
      this.setState({ [e.target.name]: e.target.value });

      if (e.target.value.length > 1) {
        const postData = {
          page: "1",
          limit: this.state.limit,
          search: e.target.value,
          merchantID: merchantID,
          cityID: this.state.default_city,
          site_id: localStorage.getItem("siteID")
        };
        this.props.getDealList(postData);
        this.props.getDealPending(postData);
        this.props.getDealUpcoming(postData);
        this.props.getDealPast(postData);
        this.props.getDealSchedule(postData);
      } else {
        const postData = {
          page: "1",
          limit: this.state.limit,
          merchantID: merchantID,
          cityID: this.state.default_city,
          site_id: localStorage.getItem("siteID")
        };
        this.props.getDealList(postData);
        this.props.getDealPending(postData);
        this.props.getDealUpcoming(postData);
        this.props.getDealPast(postData);
        this.props.getDealSchedule(postData);
      }
    }


    sorting(orderby, direction) {
      if (orderby === "skuCode" && direction === "DESC") {
        this.setState({ skuCodesortOrder: "ASC" });
        this.setState({ skuCodeIcon: "fa fa-sort-up" });
      } else {
        this.setState({ skuCodesortOrder: "DESC" });
        this.setState({ skuCodeIcon: "fa fa-sort-down" });
      }

      if (orderby === "merchantName" && direction === "DESC") {
        this.setState({ merchantNamesortOrder: "ASC" });
        this.setState({ merchantNameIcon: "fa fa-sort-up" });
      } else {
        this.setState({ merchantNamesortOrder: "DESC" });
        this.setState({ merchantNameIcon: "fa fa-sort-down" });
      }

      if (orderby === "mainDealText" && direction === "DESC") {
        this.setState({ dealTextsortOrder: "ASC" });
        this.setState({ dealTextIcon: "fa fa-sort-up" });
      } else if (orderby === "mainDealText" && direction === "ASC") {
        this.setState({ dealTextsortOrder: "DESC" });
        this.setState({ dealTextIcon: "fa fa-sort-down" });
      }


      this.setState({ orderby: orderby });
      this.setState({ direction: direction });

      const postData = {
        page: this.state.currentPage,
        limit: this.state.limit,
        search: this.state.search,
        orderBy: orderby,
        direction: direction,
        merchantID: merchantID,
        cityID: this.state.default_city,
        site_id: localStorage.getItem("siteID")
      };
      this.props.getDealList(postData);
    }

    pendingSorting(orderby, direction) {
      if (orderby === "skuCode" && direction === "DESC") {
        this.setState({ skuCodesortOrder: "ASC" });
        this.setState({ skuCodeIcon: "fa fa-sort-up" });
      } else {
        this.setState({ skuCodesortOrder: "DESC" });
        this.setState({ skuCodeIcon: "fa fa-sort-down" });
      }

      if (orderby === "merchantName" && direction === "DESC") {
        this.setState({ merchantNamesortOrder: "ASC" });
        this.setState({ merchantNameIcon: "fa fa-sort-up" });
      } else {
        this.setState({ merchantNamesortOrder: "DESC" });
        this.setState({ merchantNameIcon: "fa fa-sort-down" });
      }

      if (orderby === "mainDealText" && direction === "DESC") {
        this.setState({ dealTextsortOrder: "ASC" });
        this.setState({ dealTextIcon: "fa fa-sort-up" });
      } else if (orderby === "mainDealText" && direction === "ASC") {
        this.setState({ dealTextsortOrder: "DESC" });
        this.setState({ dealTextIcon: "fa fa-sort-down" });
      }


      this.setState({ orderby: orderby });
      this.setState({ direction: direction });

      const postData = {
        page: this.state.currentPage,
        limit: this.state.limit,
        search: this.state.search,
        orderBy: orderby,
        direction: direction,
        merchantID: merchantID,
        cityID: this.state.default_city,
        site_id: localStorage.getItem("siteID")
      };
      this.props.getDealPending(postData);
    }

    upcomingSorting(orderby, direction) {
      if (orderby === "skuCode" && direction === "DESC") {
        this.setState({ skuCodesortOrder: "ASC" });
        this.setState({ skuCodeIcon: "fa fa-sort-up" });
      } else {
        this.setState({ skuCodesortOrder: "DESC" });
        this.setState({ skuCodeIcon: "fa fa-sort-down" });
      }

      if (orderby === "merchantName" && direction === "DESC") {
        this.setState({ merchantNamesortOrder: "ASC" });
        this.setState({ merchantNameIcon: "fa fa-sort-up" });
      } else {
        this.setState({ merchantNamesortOrder: "DESC" });
        this.setState({ merchantNameIcon: "fa fa-sort-down" });
      }

      if (orderby === "mainDealText" && direction === "DESC") {
        this.setState({ dealTextsortOrder: "ASC" });
        this.setState({ dealTextIcon: "fa fa-sort-up" });
      } else if (orderby === "mainDealText" && direction === "ASC") {
        this.setState({ dealTextsortOrder: "DESC" });
        this.setState({ dealTextIcon: "fa fa-sort-down" });
      }


      this.setState({ orderby: orderby });
      this.setState({ direction: direction });

      const postData = {
        page: this.state.currentPage,
        limit: this.state.limit,
        search: this.state.search,
        orderBy: orderby,
        direction: direction,
        merchantID: merchantID,
        cityID: this.state.default_city,
        site_id: localStorage.getItem("siteID")
      };
      this.props.getDealUpcoming(postData);
    }

    scheduleSorting(orderby, direction) {
      if (orderby === "skuCode" && direction === "DESC") {
        this.setState({ skuCodesortOrder: "ASC" });
        this.setState({ skuCodeIcon: "fa fa-sort-up" });
      } else {
        this.setState({ skuCodesortOrder: "DESC" });
        this.setState({ skuCodeIcon: "fa fa-sort-down" });
      }

      if (orderby === "merchantName" && direction === "DESC") {
        this.setState({ merchantNamesortOrder: "ASC" });
        this.setState({ merchantNameIcon: "fa fa-sort-up" });
      } else {
        this.setState({ merchantNamesortOrder: "DESC" });
        this.setState({ merchantNameIcon: "fa fa-sort-down" });
      }

      if (orderby === "mainDealText" && direction === "DESC") {
        this.setState({ dealTextsortOrder: "ASC" });
        this.setState({ dealTextIcon: "fa fa-sort-up" });
      } else if (orderby === "mainDealText" && direction === "ASC") {
        this.setState({ dealTextsortOrder: "DESC" });
        this.setState({ dealTextIcon: "fa fa-sort-down" });
      }


      this.setState({ orderby: orderby });
      this.setState({ direction: direction });

      const postData = {
        page: this.state.currentPage,
        limit: this.state.limit,
        search: this.state.search,
        orderBy: orderby,
        direction: direction,
        merchantID: merchantID,
        cityID: this.state.default_city,
        site_id: localStorage.getItem("siteID")
      };
      this.props.getDealSchedule(postData);
    }

    pastSorting(orderby, direction) {
      if (orderby === "skuCode" && direction === "DESC") {
        this.setState({ skuCodesortOrder: "ASC" });
        this.setState({ skuCodeIcon: "fa fa-sort-up" });
      } else {
        this.setState({ skuCodesortOrder: "DESC" });
        this.setState({ skuCodeIcon: "fa fa-sort-down" });
      }

      if (orderby === "merchantName" && direction === "DESC") {
        this.setState({ merchantNamesortOrder: "ASC" });
        this.setState({ merchantNameIcon: "fa fa-sort-up" });
      } else {
        this.setState({ merchantNamesortOrder: "DESC" });
        this.setState({ merchantNameIcon: "fa fa-sort-down" });
      }

      if (orderby === "mainDealText" && direction === "DESC") {
        this.setState({ dealTextsortOrder: "ASC" });
        this.setState({ dealTextIcon: "fa fa-sort-up" });
      } else if (orderby === "mainDealText" && direction === "ASC") {
        this.setState({ dealTextsortOrder: "DESC" });
        this.setState({ dealTextIcon: "fa fa-sort-down" });
      }


      this.setState({ orderby: orderby });
      this.setState({ direction: direction });

      const postData = {
        page: this.state.currentPage,
        limit: this.state.limit,
        search: this.state.search,
        orderBy: orderby,
        direction: direction,
        merchantID: merchantID,
        cityID: this.state.default_city,
        site_id: localStorage.getItem("siteID")
      };
      this.props.getDealPast(postData);
    }

    

    handlePageChange = page => {
      this.setState({
        currentPage: page
      });
      if (this.state.direction !== "" && this.state.orderBy !== "") {
        this.props.getDealList({
          page: page,
          orderBy: this.state.orderBy,
          direction: this.state.direction,
          merchantID: merchantID,
          cityID: this.state.default_city,
          site_id: localStorage.getItem("siteID")
        });
      } else if (this.state.search !== "") {
        this.props.getDealList({ page: page, search: this.state.search, merchantID: merchantID, site_id: localStorage.getItem("siteID") });
      } else {
        const postData = {
          page: page,
          limit: this.state.limit,
          search: this.state.search ? this.state.search : "",
          merchantID: merchantID,
          cityID: this.state.default_city,
          site_id: localStorage.getItem("siteID")
        };
        this.props.getDealList(postData);
      }
    };

    handlePendingPageChange = page => {
      this.setState({
        pendingCurrentPage: page
      });
      if (this.state.direction !== "" && this.state.orderBy !== "") {
        this.props.getDealPending({
          page: page,
          orderBy: this.state.orderBy,
          direction: this.state.direction,
          merchantID: merchantID,
          cityID: this.state.default_city,
          site_id: localStorage.getItem("siteID")
        });
      } else if (this.state.search !== "") {
        this.props.getDealPending({ page: page, search: this.state.search, merchantID: merchantID, site_id: localStorage.getItem("siteID") });
      } else {
        const postData = {
          page: page,
          limit: this.state.limit,
          search: this.state.search ? this.state.search : "", merchantID: merchantID, cityID: this.state.default_city, site_id: localStorage.getItem("siteID")
        };
        this.props.getDealPending(postData);
      }
    };

    handleUpcomingPageChange = page => {
      this.setState({
        upcomingCurrentPage: page
      });
      if (this.state.direction !== "" && this.state.orderBy !== "") {
        this.props.getDealUpcoming({
          page: page,
          orderBy: this.state.orderBy,
          direction: this.state.direction,
          merchantID: merchantID,
          cityID: this.state.default_city,
          site_id: localStorage.getItem("siteID")
        });
      } else if (this.state.search !== "") {
        this.props.getDealUpcoming({ page: page, search: this.state.search, merchantID: merchantID, cityID: this.state.default_city, site_id: localStorage.getItem("siteID")});
      } else {
        const postData = {
          page: page,
          limit: this.state.limit,
          search: this.state.search ? this.state.search : "",
          merchantID: merchantID,
          cityID: this.state.default_city,
          site_id: localStorage.getItem("siteID")
        };
        this.props.getDealUpcoming(postData);
      }
    };

    handleSchedulePageChange = page => {
      this.setState({
        scheduleCurrentPage: page
      });
      if (this.state.direction !== "" && this.state.orderBy !== "") {
        this.props.getDealSchedule({
          page: page,
          orderBy: this.state.orderBy,
          direction: this.state.direction,
          merchantID: merchantID,
          cityID: this.state.default_city,
          site_id: localStorage.getItem("siteID")
        });
      } else if (this.state.search !== "") {
        this.props.getDealSchedule({ page: page, search: this.state.search, merchantID: merchantID, site_id: localStorage.getItem("siteID") });
      } else {
        const postData = {
          page: page,
          limit: this.state.limit,
          search: this.state.search ? this.state.search : "",
          merchantID: merchantID,
          cityID: this.state.default_city,
          site_id: localStorage.getItem("siteID")
        };
        this.props.getDealSchedule(postData);
      }
    };

    handlePastPageChange = page => {
      this.setState({
        pastCurrentPage: page
      });
      if (this.state.direction !== "" && this.state.orderBy !== "") {
        this.props.getDealPast({
          page: page,
          orderBy: this.state.orderBy,
          direction: this.state.direction,
          merchantID: merchantID,
          cityID: this.state.default_city,
          site_id: localStorage.getItem("siteID")
        });
      } else if (this.state.search !== "") {
        this.props.getDealPast({ page: page, search: this.state.search, merchantID: merchantID, site_id: localStorage.getItem("siteID") });
      } else {
        const postData = {
          page: page,
          limit: this.state.limit,
          search: this.state.search ? this.state.search : "",
          merchantID: merchantID,
          cityID: this.state.default_city,
          site_id: localStorage.getItem("siteID")
        };
        this.props.getDealPast(postData);
      }
    };

    componentDidMount() {}

    componentWillMount() {
      merchantID = (this.props.match.params && this.props.match.params.merchantID) ? this.props.match.params.merchantID : '';
      this.props.clearAlert();
      this.handleDismiss();

      let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
      let default_city;
      if(siteData){
        if(siteData.default_city){
          default_city = siteData.default_city;
          this.setState({
            default_city: siteData.default_city,
          });
        }
      }

      this.props.getSiteCity({site_id: localStorage.getItem("siteID")});
      this.props.getDealList({page:1, merchantID: merchantID, cityID: default_city, site_id: localStorage.getItem("siteID")});
      this.props.getDealPending({page:1, merchantID: merchantID, cityID: default_city, site_id: localStorage.getItem("siteID")});
      this.props.getDealUpcoming({page:1, merchantID: merchantID, cityID: default_city, site_id: localStorage.getItem("siteID")});
      this.props.getDealPast({page:1, merchantID: merchantID, cityID: default_city, site_id: localStorage.getItem("siteID")});
      this.props.getDealSchedule({page:1, merchantID: merchantID, cityID: default_city, site_id: localStorage.getItem("siteID")});
    }

    setDefaultCity = (e) => {
      let default_city = e.target.value;
      this.props.getDealList({site_id: localStorage.getItem("siteID"), page:1, merchantID: merchantID, cityID: default_city});
      this.props.getDealPending({site_id: localStorage.getItem("siteID"), page:1, merchantID: merchantID, cityID: default_city});
      this.props.getDealUpcoming({site_id: localStorage.getItem("siteID"), page:1, merchantID: merchantID, cityID: default_city});
      this.props.getDealPast({site_id: localStorage.getItem("siteID"), page:1, merchantID: merchantID, cityID: default_city});
      this.props.getDealSchedule({site_id: localStorage.getItem("siteID"), page:1, merchantID: merchantID, cityID: default_city});
      this.setState({[e.target.name] : e.target.value})
    }


    componentWillReceiveProps(nextProps) {
      if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
        this.props.history.push("/restrictedAccess");
      }
      if (this.props.dealList !== nextProps.dealList) {
        if (nextProps.dealList  != '') {
          const setPageCount =
            nextProps.dealList.total / nextProps.dealList.per_page;
          this.setState({
            dealList: nextProps.dealList.data,
            totalRecords: nextProps.dealList.total,
            perPage: nextProps.dealList.per_page,
            pageCount: setPageCount
          });
        }else{
          this.setState({
            dealList: '',
            totalRecords: 0,
            perPage: '',
            pageCount:0
          });
        }
      }

      if(this.props.orderData != nextProps.orderData){
        if(nextProps.orderData){
          this.setState({viewOrders: nextProps.orderData});
          this.handlePopupShow();
        }
      }

      if (this.props.dealPendingList !== nextProps.dealPendingList) {
        if (nextProps.dealPendingList  != '') {
          const setPageCount =
            nextProps.dealPendingList.total / nextProps.dealPendingList.per_page;
          this.setState({
            dealPendingList: nextProps.dealPendingList.data,
            pendingTotalRecords: nextProps.dealPendingList.total,
            pendingPerPage: nextProps.dealPendingList.per_page,
            pendingPageCount: setPageCount
          });
        }else{
          this.setState({
            dealPendingList: '',
            pendingTotalRecords: 0,
            pendingPerPage: 0,
            pendingPageCount: 0
          });
        }
      }

      if (this.props.dealPastList !== nextProps.dealPastList) {
        if (nextProps.dealPastList != '') {
          const setPageCount =
            nextProps.dealPastList.total / nextProps.dealPastList.per_page;
          this.setState({
            dealPastList: nextProps.dealPastList.data,
            pastTotalRecords: nextProps.dealPastList.total,
            pastPerPage: nextProps.dealPastList.per_page,
            pastPageCount: setPageCount
          });
        }else{
          this.setState({
            dealPastList: '',
            pastTotalRecords: 0,
            pastPerPage: 0,
            pastPageCount: 0
          });
        }
      }

      if (this.props.dealUpcomingList !== nextProps.dealUpcomingList) {
        if (nextProps.dealUpcomingList  != '') {
          const setPageCount =
            nextProps.dealUpcomingList.total / nextProps.dealUpcomingList.per_page;
          this.setState({
            dealUpcomingList: nextProps.dealUpcomingList.data,
            upcomingTotalRecords: nextProps.dealUpcomingList.total,
            upcomingPerPage: nextProps.dealUpcomingList.per_page,
            upcomingPageCount: setPageCount
          });
        }else{
          this.setState({
            dealUpcomingList: '',
            upcomingTotalRecords: 0,
            upcomingPerPage: 0,
            upcomingPageCount: 0
          });
        }
      }

      if (this.props.dealScheduleList !== nextProps.dealScheduleList) {
        if (nextProps.dealScheduleList  != '') {
          const setPageCount =
            nextProps.dealScheduleList.total / nextProps.dealScheduleList.per_page;
          this.setState({
            dealScheduleList: nextProps.dealScheduleList.data,
            scheduleTotalRecords: nextProps.dealScheduleList.total,
            schedulePerPage: nextProps.dealScheduleList.per_page,
            schedulePageCount: setPageCount
          });
        }else{
          this.setState({
            dealScheduleList: '',
            scheduleTotalRecords: 0,
            schedulePerPage: 0,
            schedulePageCount: 0
          });
        }
      }

      if (this.props.dealDeleted !== nextProps.dealDeleted) {
        if (!isEmpty(nextProps.dealDeleted)) {
          this.props.clearAlert();
          this.handleShow();
          this.props.renderAlert("success", nextProps.dealDeleted.message);
          this.handlePageChange(this.state.currentPage);
        } else {
          this.props.clearAlert();
        }
      }
      if (this.props.quantityStatus !== nextProps.quantityStatus) {
        if (!isEmpty(nextProps.quantityStatus)) {
          this.props.clearAlert();
          this.handleShow();
          this.props.renderAlert("success", nextProps.quantityStatus.message);
          this.props.getOrderDeatil(this.state.orderID, localStorage.getItem("siteID"));
          this.handlePageChange(this.state.currentPage);
          this.setState({updateqty: '', updatekey: 'Update'});
        } else {
          this.props.clearAlert();
        }
      }
      if (this.props.closeStatus !== nextProps.closeStatus) {
        if (nextProps.closeStatus) {
          this.props.clearAlert();
          this.handleShow();
          this.props.renderAlert("success", nextProps.closeStatus.message);
          this.handlePageChange(this.state.currentPage);
        }
      }

      if (this.props.voucherStatus !== nextProps.voucherStatus) {
        if (nextProps.voucherStatus) {
          this.props.clearAlert();
          this.handleShow();
          if(nextProps.voucherStatus.response == 'success'){
            this.loadVoucherClose();
            this.props.renderAlert("success", nextProps.voucherStatus.message);
          }else{
            this.props.renderAlert("danger", nextProps.voucherStatus.message);
          }
          this.handlePageChange(this.state.currentPage);
          this.setState({uploadButton: 'Upload File'});
        }
      }

      if (this.props.error !== nextProps.error) {
        if (nextProps.error) {
          this.props.clearAlert();
          this.handleShow();
          this.props.renderAlert("warning", nextProps.error);
          this.setState({uploadButton: 'Upload File'});
        }
      }

      if (this.props.dealError !== nextProps.dealError) {
        if (nextProps.dealError) {
          this.props.clearAlert();
          this.handleShow();
          this.loadVoucherClose();
          this.props.renderAlert("warning", nextProps.dealError);
        }
      }

      if (nextProps.message) {
        this.handleShow();
        this.setState({
          alertMessage: nextProps.message,
          msgType: nextProps.alertType
        });
      }

      if(this.props.cityList != nextProps.cityList){
        if(nextProps.cityList){
          this.setState({cityList: nextProps.cityList.data});
          if(nextProps.cityList.data[0] && nextProps.cityList.data[0].cities[0] && nextProps.cityList.data[0].cities[0].cityID){
            this.setState({default_city: nextProps.cityList.data[0].cities[0].cityID});
            this.props.getDealList({site_id: localStorage.getItem("siteID"), page:1, merchantID: merchantID, cityID: nextProps.cityList.data[0].cities[0].cityID});
            this.props.getDealPending({site_id: localStorage.getItem("siteID"), page:1, merchantID: merchantID, cityID: nextProps.cityList.data[0].cities[0].cityID});
            this.props.getDealUpcoming({site_id: localStorage.getItem("siteID"), page:1, merchantID: merchantID, cityID: nextProps.cityList.data[0].cities[0].cityID});
            this.props.getDealPast({site_id: localStorage.getItem("siteID"), page:1, merchantID: merchantID, cityID: nextProps.cityList.data[0].cities[0].cityID});
            this.props.getDealSchedule({site_id: localStorage.getItem("siteID"), page:1, merchantID: merchantID, cityID: nextProps.cityList.data[0].cities[0].cityID});
          }
        }
      }
    }

    handleDelete = dealID => {
      this.dialog.show({
        body: "Are you sure you want to delete this?",
        actions: [
          Dialog.CancelAction(),
          Dialog.OKAction(() => {
            this.confirmDelete(dealID);
          })
        ]
      });
    };

    handleTabs = data => {
      this.setState({
        skuCodeIcon: "fa fa-sort-down",
        merchantNameIcon: "fa fa-sort-down",
        dealTextIcon: "fa fa-sort-down",
      })
    }

    newWindow = (dealID, url) => {
      window.open('/#/'+url+dealID, '_blank');
    }

    handleChange = (e) => {
      this.setState({[e.target.name] : e.target.value, quantityError: ''})
    }

    setQuantity = (e) => {
      this.setState({quantityID: e.target.attributes.getNamedItem("data-id").value, updateqty: ''});
    }

    updateQty = (e) => {
      if(this.state.updateqty){
        this.setState({updatekey: 'Updating...'})
        this.props.updateQuantity({dealID: this.state.quantityID, quantity: this.state.updateqty, site_id: localStorage.getItem("siteID")})
      }else{
        this.setState({updateqtyError: 'red'});
      }
    }

    cancelQuantity = (e) => {
      this.setState({quantityID: '', quantity: ''});
    }

    render() {
      const { path } = this.state;
      const { currentPage, totalRecords, perPage, pageCount, pendingCurrentPage, pendingTotalRecords, pendingPerPage, pendingPageCount, upcomingCurrentPage, upcomingTotalRecords, upcomingPerPage, upcomingPageCount, pastCurrentPage, pastTotalRecords, pastPerPage, pastPageCount, scheduleTotalRecords, schedulePerPage, schedulePageCount, scheduleCurrentPage } = this.state;
      let dealRow, dealRowPending, dealRowPast, dealRowUnschedule, dealRowSchedule;

      if (!isEmpty(this.state.dealPastList)) {
        dealRowPast = this.state.dealPastList.map((deal, index) => (
          <tr key={Math.random()}>
            <td>{deal.skuCode}</td>
            <td>{deal.executedOn}</td>
            <td>{deal.merchantName}</td>
            <td>{deal.dealText}</td>
            <td className="text-danger">
              <b>${(deal.revenue) ? deal.revenue : "0.00"}</b>
            </td>
            <td>
              {!isEmpty(deal.startDateTime)
                ? deal.startDateTime + "-" + deal.expiryDateTime
                : "Not Scheduled"}
            </td>
            <td>
              <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL('EDIT_OFFER') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/editDeal/${deal.dealID}`)}>Edit Deal</MenuItem>):("")}
                  {aclUtil.checkACL('EDIT_CONTRACT') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/addContract/${deal.contractID}/edit`)}>Edit Contract</MenuItem>):("")}
                  {/*<MenuItem eventKey={Math.random()} onClick={this.newWindow.bind(this, deal.deal_id, 'deals-detail/')}>Preview Deal</MenuItem>}
                  {aclUtil.checkACL('VIEW_LEAD') ? (<MenuItem eventKey={Math.random()} data-id={deal.dealID} onClick={this.viewOrders}>View Orders</MenuItem>):("")*/}
                  {aclUtil.checkACL('CLONE_CONTRACT') ? (<MenuItem eventKey={Math.random()}   onClick={() => history.push(`/addContract/${deal.contractID}/clone`)} >Clone</MenuItem>):("")}
                </DropdownButton>
              </ButtonGroup>
            </td>
          </tr>
        ));
      }


      if (!isEmpty(this.state.dealUpcomingList)) {
        dealRowUnschedule = this.state.dealUpcomingList.map((deal, index) => (
          <tr key={Math.random()}>
            <td>{deal.skuCode}</td>
            <td>{deal.executedOn}</td>
            <td>{deal.merchantName}</td>
            <td>{deal.dealText}</td>
            <td className="text-danger">
              <b>${(deal.revenue) ? deal.revenue : "0.00"}</b>
            </td>
            <td>
              {!isEmpty(deal.startDateTime)
                ? deal.startDateTime + "-" + deal.expiryDateTime
                : "Not Scheduled"}
            </td>
            <td>
            <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL('EDIT_OFFER') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/editDeal/${deal.dealID}`)}>Edit Deal</MenuItem>):("")}
                  {aclUtil.checkACL('EDIT_CONTRACT') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/addContract/${deal.contractID}/edit`)}>Edit Contract</MenuItem>):("")}
                  {/*<MenuItem eventKey={Math.random()} onClick={this.newWindow.bind(this, deal.deal_id, 'deals-detail/')}>Preview Deal</MenuItem>}
                  {aclUtil.checkACL('VIEW_LEAD') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/merchantDetails/${deal.uID}`)}>View Lead</MenuItem>):("")*/}
                  <MenuItem eventKey={Math.random()} data-id={deal.dealID} onClick={this.viewOrders}>View Orders</MenuItem>
                  {aclUtil.checkACL('CLONE_CONTRACT') ? (<MenuItem eventKey={Math.random()}   onClick={() => history.push(`/addContract/${deal.contractID}/clone`)} >Clone</MenuItem>):("")}
                </DropdownButton>
            </ButtonGroup>
            </td>
          </tr>
        ));
      }

      if (!isEmpty(this.state.dealScheduleList)) {
        dealRowSchedule = this.state.dealScheduleList.map((deal, index) => (
          <tr key={Math.random()}>
            <td>{deal.skuCode}</td>
            <td>{deal.executedOn}</td>
            <td>{deal.merchantName}</td>
            <td>{deal.dealText}</td>
            <td className="text-danger">
              <b>${(deal.revenue) ? deal.revenue : "0.00"}</b>
            </td>
            <td>
              {!isEmpty(deal.startDateTime)
                ? deal.startDateTime + "-" + deal.expiryDateTime
                : "Not Scheduled"}
            </td>
            <td>
            <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL('EDIT_OFFER') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/editDeal/${deal.dealID}`)}>Edit Deal</MenuItem>):("")}
                  {aclUtil.checkACL('EDIT_CONTRACT') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/addContract/${deal.contractID}/edit`)}>Edit Contract</MenuItem>):("")}
                  {/*<MenuItem eventKey={Math.random()} onClick={this.newWindow.bind(this, deal.deal_id, 'deals-detail/')}>Preview Deal</MenuItem>
                  {aclUtil.checkACL('VIEW_LEAD') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/merchantDetails/${deal.uID}`)}>View Lead</MenuItem>):("")*/}
                  <MenuItem eventKey={Math.random()} data-id={deal.dealID} onClick={this.viewOrders}>View Orders</MenuItem>
                  {aclUtil.checkACL('CLONE_CONTRACT') ? (<MenuItem eventKey={Math.random()}   onClick={() => history.push(`/addContract/${deal.contractID}/clone`)} >Clone</MenuItem>):("")}
                </DropdownButton>
            </ButtonGroup>
            </td>
          </tr>
        ));
      }

      if (!isEmpty(this.state.dealPendingList)) {
        dealRowPending = this.state.dealPendingList.map((deal, index) => (
          <tr key={Math.random()}>
            <td>{deal.skuCode}</td>
            <td>{deal.executedOn}</td>
            <td>{deal.merchantName}</td>
            <td>{deal.dealText}</td>
            <td className="text-danger">
              <b>${(deal.revenue) ? deal.revenue : "0.00"}</b>
            </td>
            <td>
              {!isEmpty(deal.startDateTime)
                ? deal.startDateTime + "-" + deal.expiryDateTime
                : "Not Scheduled"}
            </td>
            <td>
              <ButtonGroup>
                  <DropdownButton title="Action" id="bg-nested-dropdown">
                    {aclUtil.checkACL('EDIT_OFFER') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/editDeal/${deal.dealID}`)}>Edit Deal</MenuItem>):("")}
                    {aclUtil.checkACL('EDIT_CONTRACT') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/addContract/${deal.contractID}/edit`)}>Edit Contract</MenuItem>):("")}
                    {/*<MenuItem eventKey={Math.random()} onClick={this.newWindow.bind(this, deal.deal_id, 'deals-detail/')}>Preview Deal</MenuItem>
                    {aclUtil.checkACL('VIEW_LEAD') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/merchantDetails/${deal.uID}`)}>View Lead</MenuItem>):("")*/}
                    {aclUtil.checkACL('CLONE_CONTRACT') ? (<MenuItem eventKey={Math.random()}  onClick={() => history.push(`/addContract/${deal.contractID}/clone`)}>Clone</MenuItem>):("")}
                  </DropdownButton>
              </ButtonGroup>
            </td>
          </tr>
        ));
      }

      

      if (!isEmpty(this.state.dealList)) {
        dealRow = this.state.dealList.map((deal, index) => (
          <tr key={Math.random()}>
            <td>{deal.skuCode}</td>
            <td>{deal.executedOn}</td>
            <td>{deal.merchantName}</td>
            <td>{deal.dealText}</td>
            <td className="text-danger">
              <b>${(deal.revenue) ? deal.revenue : "0.00"}</b>
            </td>
            <td>
              {!isEmpty(deal.startDateTime)
                ? deal.startDateTime + "-" + deal.expiryDateTime
                : "Not Scheduled"}
            </td>
            <td>
              <ButtonGroup>
                  <DropdownButton title="Action" id="bg-nested-dropdown">
                    {aclUtil.checkACL('EDIT_OFFER') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/editDeal/${deal.dealID}`)}>Edit Deal</MenuItem>):("")}
                    {aclUtil.checkACL('EDIT_CONTRACT') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/addContract/${deal.contractID}/edit`)}>Edit Contract</MenuItem>):("")}
                    {/*<MenuItem eventKey={Math.random()} onClick={this.newWindow.bind(this, deal.deal_id, 'deals-detail/')}>Preview Deal</MenuItem>
                    {aclUtil.checkACL('VIEW_LEAD') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/merchantDetails/${deal.uID}`)}>View Lead</MenuItem>):("")*/}
                    <MenuItem eventKey={Math.random()} data-id={deal.dealID} onClick={this.viewOrders}>View Orders</MenuItem>
                    {aclUtil.checkACL('CLONE_CONTRACT') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/addContract/${deal.contractID}/clone`)} >Clone</MenuItem>):("")}
                    {aclUtil.checkACL('CLOSE_OFFER') ? (<MenuItem eventKey={Math.random()} data-id={deal.dealID} onClick={this.closeOffer}>Close Offer</MenuItem>):("")}
                    {(deal.useExternalCoupon == 1) &&
                    <MenuItem eventKey={Math.random()} data-id={deal.contractID} onClick={this.loadVoucher}>Load Voucher</MenuItem>
                    }
                    {(deal.useExternalCoupon == 1) &&
                    <MenuItem eventKey={Math.random()} onClick={this.newWindow.bind(this, deal.dealID, 'uploaded-vouchers/')}>Uploaded Voucher</MenuItem>
                    }
                  </DropdownButton>
              </ButtonGroup>
            </td>
          </tr>
        ));
      }
      return (
        <div>
          <Dialog
            ref={el => {
              this.dialog = el;
            }}
          />
          <div className="col-lg-12 list-page">
            <div className="row">
              <div className="col-xs-12">
                <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
              </div>
            </div>
            <div className="panel">
            <header className="panel-heading panel-heading-index">
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <h4>Deal/Offer List</h4>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12">
                  <FormGroup>
                      <FormControl componentClass="select" value={this.state.default_city} placeholder="select" name="default_city" onChange={this.setDefaultCity}>
                        <option value="">Choose Region/City</option>
                        {(this.state.cityList) &&
                          this.state.cityList.map((data, index) =>
                            <optgroup key={'hcity'+index} label={data.country}>
                              {(data.cities) &&
                                data.cities.map((city, index) => 
                                  <option key={'hcityval'+index} value={city.cityID}>{city.title}</option>
                                )
                              }
                            </optgroup>
                          )
                        }
                      </FormControl>
                  </FormGroup>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12">
                    <FormGroup>
                    <InputGroup>
                      <FormControl type="text" name="search" onKeyUp={this.handleSearch} />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-12">
                  <DropdownButton
                    bsSize="small"
                    bsStyle="default"
                    title={this.state.selectedOption}
                    onSelect={this.handleSelect}
                    id="0"
                  >
                   {options.map((opt, i) => (
                    <MenuItem key={i} eventKey={i}>
                      {opt}
                    </MenuItem>
                  ))}
                  </DropdownButton>
                </div>
              </div>
            </header>
              <div className="panel-body">
                {this.state.messageShow &&
                  this.state.alertMessage !== "" && (
                    <div className="col-lg-12">
                      <Alert
                        bsStyle={this.state.msgType}
                        onDismiss={this.handleDismiss}
                      >
                        <strong>{this.state.msgType}:</strong>{" "}
                        {this.state.alertMessage}
                      </Alert>
                    </div>
                  )}
                <Row>
                  <Col xs={12} md={12}>
                  <Tabs
                    activeKey={this.state.key}
                    onSelect={this.handleTabs}
                    id="controlled-tab-example"
                  >
                     <Tab eventKey={1} title="Current Offers">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th
                                onClick={this.sorting.bind(
                                  this,
                                  "skuCode",
                                  this.state.skuCodesortOrder
                                )}
                              >
                                SKU Code <i className={this.state.skuCodeIcon} />
                              </th>
                              <th>Executed On</th>
                              <th
                                onClick={this.sorting.bind(
                                  this,
                                  "merchantName",
                                  this.state.merchantNamesortOrder
                                )}
                              >
                                Merchant Name{" "}
                                <i className={this.state.merchantNameIcon} />
                              </th>
                              <th
                                onClick={this.sorting.bind(
                                  this,
                                  "mainDealText",
                                  this.state.dealTextsortOrder
                                )}
                              >
                                Offer <i className={this.state.dealTextIcon} />
                              </th>
                              <th>Revenue</th>
                              <th>Schedule</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>{dealRow}</tbody>
                        </table>

                        <div className="text-center">
                          <Pagination
                            total={totalRecords}
                            limit={perPage}
                            pageCount={pageCount}
                            currentPage={currentPage}
                          >
                            {({
                              pages,
                              currentPage,
                              hasNextPage,
                              hasPreviousPage,
                              previousPage,
                              nextPage,
                              totalPages,
                              getPageItemProps
                            }) => (
                              <div className="pagination">
                                <button className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: 1,
                                    onPageChange: this.handlePageChange
                                  })}
                                >
                                  first
                                </button>

                                {hasPreviousPage && (
                                  <button className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: previousPage,
                                      onPageChange: this.handlePageChange
                                    })}
                                  >
                                    {"<"}
                                  </button>
                                )}

                                {pages.map(page => {
                                  let activePage = null;
                                  if (currentPage === page) {
                                    activePage = {
                                      backgroundColor: "#ccc",
                                      color: "#666"
                                    };
                                  }
                                  return (
                                    <button className="btn btn-default"
                                      key={page}
                                      style={activePage}
                                      {...getPageItemProps({
                                        pageValue: page,
                                        onPageChange: this.handlePageChange
                                      })}
                                    >
                                      {page}
                                    </button>
                                  );
                                })}

                                {hasNextPage && (
                                  <button className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: nextPage,
                                      onPageChange: this.handlePageChange
                                    })}
                                  >
                                    {">"}
                                  </button>
                                )}

                                <button className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: totalPages,
                                    onPageChange: this.handlePageChange
                                  })}
                                >
                                  last
                                </button>
                              </div>
                            )}
                          </Pagination>
                          </div>
                     </Tab>
                     {aclUtil.checkACL('FUTURE_CONTRACT') ? (
                     <Tab eventKey={2} title="Upcoming Offers">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th
                                onClick={this.upcomingSorting.bind(
                                  this,
                                  "skuCode",
                                  this.state.skuCodesortOrder
                                )}
                              >
                                SKU Code <i className={this.state.skuCodeIcon} />
                              </th>
                              <th>Executed On</th>
                              <th
                                onClick={this.upcomingSorting.bind(
                                  this,
                                  "merchantName",
                                  this.state.merchantNamesortOrder
                                )}
                              >
                                Merchant Name{" "}
                                <i className={this.state.merchantNameIcon} />
                              </th>
                              <th
                                onClick={this.upcomingSorting.bind(
                                  this,
                                  "mainDealText",
                                  this.state.dealTextsortOrder
                                )}
                              >
                                Offer <i className={this.state.dealTextIcon} />
                              </th>
                              <th>Revenue</th>
                              <th>Schedule</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>{dealRowUnschedule}</tbody>
                        </table>

                        <div className="text-center">
                          <Pagination
                            total={upcomingTotalRecords}
                            limit={upcomingPerPage}
                            pageCount={upcomingPageCount}
                            currentPage={upcomingCurrentPage}
                          >
                            {({
                              pages,
                              currentPage,
                              hasNextPage,
                              hasPreviousPage,
                              previousPage,
                              nextPage,
                              totalPages,
                              getPageItemProps
                            }) => (
                              <div className="pagination">
                                <button className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: 1,
                                    onPageChange: this.handleUpcomingPageChange
                                  })}
                                >
                                  first
                                </button>

                                {hasPreviousPage && (
                                  <button className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: previousPage,
                                      onPageChange: this.handleUpcomingPageChange
                                    })}
                                  >
                                    {"<"}
                                  </button>
                                )}

                                {pages.map(page => {
                                  let activePage = null;
                                  if (currentPage === page) {
                                    activePage = {
                                      backgroundColor: "#ccc",
                                      color: "#666"
                                    };
                                  }
                                  return (
                                    <button className="btn btn-default"
                                      key={page}
                                      style={activePage}
                                      {...getPageItemProps({
                                        pageValue: page,
                                        onPageChange: this.handleUpcomingPageChange
                                      })}
                                    >
                                      {page}
                                    </button>
                                  );
                                })}

                                {hasNextPage && (
                                  <button className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: nextPage,
                                      onPageChange: this.handleUpcomingPageChange
                                    })}
                                  >
                                    {">"}
                                  </button>
                                )}

                                <button className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: totalPages,
                                    onPageChange: this.handleUpcomingPageChange
                                  })}
                                >
                                  last
                                </button>
                              </div>
                            )}
                          </Pagination>
                          </div>
                     </Tab>
                     ) :("")}
                     {aclUtil.checkACL('SCHEDULE_CONTRACT') ? (
                     <Tab eventKey={3} title="Scheduled Offers">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th
                                onClick={this.scheduleSorting.bind(
                                  this,
                                  "skuCode",
                                  this.state.skuCodesortOrder
                                )}
                              >
                                SKU Code <i className={this.state.skuCodeIcon} />
                              </th>
                              <th>Executed On</th>
                              <th
                                onClick={this.scheduleSorting.bind(
                                  this,
                                  "merchantName",
                                  this.state.merchantNamesortOrder
                                )}
                              >
                                Merchant Name{" "}
                                <i className={this.state.merchantNameIcon} />
                              </th>
                              <th
                                onClick={this.scheduleSorting.bind(
                                  this,
                                  "mainDealText",
                                  this.state.dealTextsortOrder
                                )}
                              >
                                Offer <i className={this.state.dealTextIcon} />
                              </th>
                              <th>Revenue</th>
                              <th>Schedule</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>{dealRowSchedule}</tbody>
                        </table>
                        <div className="text-center">
                          <Pagination
                            total={scheduleTotalRecords}
                            limit={schedulePerPage}
                            pageCount={schedulePageCount}
                            currentPage={scheduleCurrentPage}
                          >
                            {({
                              pages,
                              currentPage,
                              hasNextPage,
                              hasPreviousPage,
                              previousPage,
                              nextPage,
                              totalPages,
                              getPageItemProps
                            }) => (
                              <div className="pagination">
                                <button className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: 1,
                                    onPageChange: this.handleSchedulePageChange
                                  })}
                                >
                                  first
                                </button>

                                {hasPreviousPage && (
                                  <button className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: previousPage,
                                      onPageChange: this.handleSchedulePageChange
                                    })}
                                  >
                                    {"<"}
                                  </button>
                                )}

                                {pages.map(page => {
                                  let activePage = null;
                                  if (currentPage === page) {
                                    activePage = {
                                      backgroundColor: "#ccc",
                                      color: "#666"
                                    };
                                  }
                                  return (
                                    <button className="btn btn-default"
                                      key={page}
                                      style={activePage}
                                      {...getPageItemProps({
                                        pageValue: page,
                                        onPageChange: this.handleSchedulePageChange
                                      })}
                                    >
                                      {page}
                                    </button>
                                  );
                                })}

                                {hasNextPage && (
                                  <button className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: nextPage,
                                      onPageChange: this.handleSchedulePageChange
                                    })}
                                  >
                                    {">"}
                                  </button>
                                )}
                                <button className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: totalPages,
                                    onPageChange: this.handleSchedulePageChange
                                  })}
                                >
                                  last
                                </button>
                              </div>
                            )}
                          </Pagination>
                        </div>                        

                     </Tab>
                     ) :("")}
                     {aclUtil.checkACL('PENDING_CONTRACT') ? (
                     <Tab eventKey={4} title="Pending Offers">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th
                                onClick={this.pendingSorting.bind(
                                  this,
                                  "skuCode",
                                  this.state.skuCodesortOrder
                                )}
                              >
                                SKU Code <i className={this.state.skuCodeIcon} />
                              </th>
                              <th>Executed On</th>
                              <th
                                onClick={this.pendingSorting.bind(
                                  this,
                                  "merchantName",
                                  this.state.merchantNamesortOrder
                                )}
                              >
                                Merchant Name{" "}
                                <i className={this.state.merchantNameIcon} />
                              </th>
                              <th
                                onClick={this.pendingSorting.bind(
                                  this,
                                  "mainDealText",
                                  this.state.dealTextsortOrder
                                )}
                              >
                                Offer <i className={this.state.dealTextIcon} />
                              </th>
                              <th>Revenue</th>
                              <th>Schedule</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>{dealRowPending}</tbody>
                        </table>

                        <div className="text-center">
                          <Pagination
                            total={pendingTotalRecords}
                            limit={pendingPerPage}
                            pageCount={pendingPageCount}
                            currentPage={pendingCurrentPage}
                          >
                            {({
                              pages,
                              currentPage,
                              hasNextPage,
                              hasPreviousPage,
                              previousPage,
                              nextPage,
                              totalPages,
                              getPageItemProps
                            }) => (
                              <div className="pagination">
                                <button className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: 1,
                                    onPageChange: this.handlePendingPageChange
                                  })}
                                >
                                  first
                                </button>

                                {hasPreviousPage && (
                                  <button className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: previousPage,
                                      onPageChange: this.handlePendingPageChange
                                    })}
                                  >
                                    {"<"}
                                  </button>
                                )}

                                {pages.map(page => {
                                  let activePage = null;
                                  if (currentPage === page) {
                                    activePage = {
                                      backgroundColor: "#ccc",
                                      color: "#666"
                                    };
                                  }
                                  return (
                                    <button className="btn btn-default"
                                      key={page}
                                      style={activePage}
                                      {...getPageItemProps({
                                        pageValue: page,
                                        onPageChange: this.handlePendingPageChange
                                      })}
                                    >
                                      {page}
                                    </button>
                                  );
                                })}

                                {hasNextPage && (
                                  <button className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: nextPage,
                                      onPageChange: this.handlePendingPageChange
                                    })}
                                  >
                                    {">"}
                                  </button>
                                )}

                                <button className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: totalPages,
                                    onPageChange: this.handlePendingPageChange
                                  })}
                                >
                                  last
                                </button>
                              </div>
                            )}
                          </Pagination>
                          </div>
                     </Tab>
                     ) :("")}
                     {aclUtil.checkACL('PAST_CONTRACT') ? (
                     <Tab eventKey={5} title="Past Offers">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th
                                onClick={this.pastSorting.bind(
                                  this,
                                  "skuCode",
                                  this.state.skuCodesortOrder
                                )}
                              >
                                SKU Code <i className={this.state.skuCodeIcon} />
                              </th>
                              <th>Executed On</th>
                              <th
                                onClick={this.pastSorting.bind(
                                  this,
                                  "merchantName",
                                  this.state.merchantNamesortOrder
                                )}
                              >
                                Merchant Name{" "}
                                <i className={this.state.merchantNameIcon} />
                              </th>
                              <th
                                onClick={this.pastSorting.bind(
                                  this,
                                  "mainDealText",
                                  this.state.dealTextsortOrder
                                )}
                              >
                                Offer <i className={this.state.dealTextIcon} />
                              </th>
                              <th>Revenue</th>
                              <th>Schedule</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>{dealRowPast}</tbody>
                        </table>

                        <div className="text-center">
                          <Pagination
                            total={pastTotalRecords}
                            limit={pastPerPage}
                            pageCount={pastPageCount}
                            currentPage={pastCurrentPage}
                          >
                            {({
                              pages,
                              currentPage,
                              hasNextPage,
                              hasPreviousPage,
                              previousPage,
                              nextPage,
                              totalPages,
                              getPageItemProps
                            }) => (
                              <div className="pagination">
                                <button className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: 1,
                                    onPageChange: this.handlePastPageChange
                                  })}
                                >
                                  first
                                </button>

                                {hasPreviousPage && (
                                  <button className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: previousPage,
                                      onPageChange: this.handlePageChange
                                    })}
                                  >
                                    {"<"}
                                  </button>
                                )}

                                {pages.map(page => {
                                  let activePage = null;
                                  if (currentPage === page) {
                                    activePage = {
                                      backgroundColor: "#ccc",
                                      color: "#666"
                                    };
                                  }
                                  return (
                                    <button className="btn btn-default"
                                      key={page}
                                      style={activePage}
                                      {...getPageItemProps({
                                        pageValue: page,
                                        onPageChange: this.handlePastPageChange
                                      })}
                                    >
                                      {page}
                                    </button>
                                  );
                                })}

                                {hasNextPage && (
                                  <button className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: nextPage,
                                      onPageChange: this.handlePastPageChange
                                    })}
                                  >
                                    {">"}
                                  </button>
                                )}

                                <button className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: totalPages,
                                    onPageChange: this.handlePastPageChange
                                  })}
                                >
                                  last
                                </button>
                              </div>
                            )}
                          </Pagination>
                          </div>
                     </Tab>
                     ) :("")}
                  </Tabs>
                  </Col>
                </Row>
                <div className="row">
                  <div className="col-lg-12">
                    
                  </div>
                </div>
                <div className="clearfix" />
              </div>
            </div>
          </div>
          
          <Modal show={this.state.show} onHide={this.handleClose.bind(this)} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title>Orders Detail</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Available</th>
                    <th>Sold</th>
                    <th>Left</th>
                  </tr>
                </thead>
                <tbody>
                  {(this.state.viewOrders) &&
                    this.state.viewOrders.map((data, key) => 
                    <React.Fragment>
                    <tr key={Math.random()}>
                      <td>{data.dealText} <Button bsSize="xsmall" data-id={data.dealID} onClick={this.setQuantity} bsStyle="success">Update Quantity</Button></td>
                      <td>{data.total}</td>
                      <td>{data.quantity}</td>
                      <td>{data.total - data.quantity}</td>
                    </tr>
                    {(this.state.quantityID == data.dealID) &&
                      <tr key={data.dealID+key+'s'}>
                        <td>Set Quantity</td>
                        <td>
                          <FormControl
                            type="number"
                            value={this.state.updateqty}
                            name="updateqty"
                            placeholder="Enter Quantity"
                            onChange={this.handleChange}
                            style={{ borderColor: this.state.updateqtyError }}
                          />
                        </td>
                        <td><Button bsSize="xsmall" data-id={data.dealID} onClick={this.updateQty} bsStyle="success">{this.state.updatekey}</Button></td>
                        <td><Button bsSize="xsmall" onClick={this.cancelQuantity} bsStyle="danger">Cancel</Button></td>
                      </tr>
                    }
                    </React.Fragment>
                  )}
                </tbody>
              </table>
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="danger" onClick={this.handleClose.bind(this)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal show={this.state.loadVoucherStatus} onHide={this.loadVoucherClose.bind(this)}>
            <Modal.Header closeButton>
              <Modal.Title>Load External Voucher</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormControl
                type="file"
                id="file"
                onChange={this.handleFormData}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="success" onClick={this.uploadVoucher.bind(this)}>
                {this.state.uploadButton}
              </Button>
              <CSVLink
                data={this.state.csvData}
                filename={"exportVoucher.csv"}
                className="btn btn-default pull-left"
              >
                Download Demo File
              </CSVLink>
              <Button bsStyle="danger" onClick={this.loadVoucherClose.bind(this)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      );
    }
  }

  DealtList.propTypes = {
    getDealList: PropTypes.func.isRequired,
    getDealPending: PropTypes.func.isRequired,
    getDealUpcoming: PropTypes.func.isRequired, 
    getDealPast: PropTypes.func.isRequired,
    deleteDeal: PropTypes.func.isRequired,
    getOrderDeatil: PropTypes.func.isRequired,
    updateQuantity: PropTypes.func.isRequired,
  };

  const mapStateToProps = state => ({
    dealList: state.dealReducer.dealList,
    dealPendingList: state.dealReducer.dealPendingList,
    dealUpcomingList: state.dealReducer.dealUpcomingList,
    dealPastList: state.dealReducer.dealPastList,
    dealDeleted: state.dealReducer.dealDeleted,
    error: state.contractReducer.error,
    alertType: state.alertsReducer.alertType,
    orderData: state.dealReducer.orderData,
    message: state.alertsReducer.message,
    closeStatus: state.dealReducer.closeStatus,
    voucherStatus: state.dealReducer.voucherStatus,
    dealError: state.dealReducer.error,
    dealScheduleList: state.dealReducer.dealScheduleList,
    quantityStatus: state.dealReducer.quantityStatus,
    cityList: state.frontReducer.cityList,
  });

  export default withRouter(connect(mapStateToProps, {
    getDealList,
    getDealPending,
    getDealUpcoming, 
    getDealPast,
    deleteDeal,
    renderAlert,
    getOrderDeatil,
    clearAlert,
    confirmClose,
    uploadExternalVoucher,
    getDealSchedule,
    updateQuantity,
    getSiteCity,
  })(DealtList));



// WEBPACK FOOTER //
// ./src/app/views/admin/deal/DealList.js